var STATUS_BAR_ITEMS = [
    { label: 'Not conected' },
    { label: 'Conected' },
    { label: 'Not converted' },
    { label: 'Converted' }
];
export default STATUS_BAR_ITEMS;
//# sourceMappingURL=statusBarItems.js.map